const basketTokenName = 'hrpwtBT';

export function setBasketToken(token) {
  window.sessionStorage.setItem(basketTokenName, token);
}

export function isBasketToken() {
  if (window.sessionStorage.getItem(basketTokenName)) {
    return true;
  } else {
    return false;
  }
}

export function getBasketToken() {
  return window.sessionStorage.getItem(basketTokenName);
}

export function removeBasketToken() {
  window.sessionStorage.removeItem(basketTokenName);
}
